import Injection = EECore.Injection;
import Model from "../models/promotion/promotionModel";
import PromotionService from "../../services/promotion/promotionService";

@Injection.injectableClass("SecuredMessaging")
export default class SecuredMessaging implements EECore.UI.IWebComponent {
  @Injection.injectableProperty("SecuredMessaging", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("SecuredMessaging", EECore.Registrations.HTML_HELPER)
  private htmlHelper: EECore.HtmlHelper;

  @Injection.injectableProperty("SecuredMessaging", "PromotionService")
  private promotionService: PromotionService;

  @Injection.injectableProperty("SecuredMessaging", EECore.Registrations.TEALIUM)
  private tealium: EECore.Tealium;

  constructor(templateFactory: EECore.UI.TemplateFactory, htmlHelper: EECore.HtmlHelper, promotionService: PromotionService, tealium: EECore.Tealium) {
    this.tealium = tealium;
    this.htmlHelper = htmlHelper;
    this.templateFactory = templateFactory;
    this.promotionService = promotionService;
  }

  load() {
    const contentRequest = this.promotionService.getSecuredMessagingContent();

    return new EECore.Promise<Element, string>((resolve, reject) => {
      EECore.Promise.all(contentRequest).then((result) => {
        const promotionElement = this.render(result[0]);
        resolve(promotionElement);
        this.bindEvents(promotionElement);
        this.scheduleDisplay(promotionElement);
      }).catch(() => {
        reject("Could not get the promotion information");
      });
    });
  }

  private render(content: string): Element {
    const model: Model = { content: content };
    const template = this.templateFactory.getTemplate("SecuredMessaging", model);

    this.customizeContent(template);

    return template;
  }

  private bindEvents(content: Element) {
    const dismissButton = content.querySelector(".close-button");
    dismissButton.addEventListener("click", () => {
      this.promotionService.updateReminder("SECURED_MESSAGING_PROMOTION").then(() => {
        this.htmlHelper.removeCssClass(content, "active");
        (content.querySelector(".we_overlayBannerOverlay") as HTMLElement).style.display = "none";
        (content.querySelector(".we_overlayBannerContent") as HTMLElement).style.display = "none";
      });
    });
  }

  private scheduleDisplay(content: Element) {
    (content.querySelector(".we_overlayBannerOverlay") as HTMLElement).style.display = "block";
    (content.querySelector(".we_overlayBannerContent") as HTMLElement).style.display = "block";
    setTimeout(() => {
      this.htmlHelper.addCssClass(content, "active");
    }, 500);
  }

  private customizeContent(content: Element) {
    (content.querySelector(".banner-image") as HTMLElement).style.backgroundColor = "#e1f6fb";
  }
}